export interface IOrganizationKeyOutputDto {
    id: string;
    organizationId: string;
    name: string;
    apiKey: string;
    ipWhitelist: {
        value: string;
        enabled: boolean;
    }[];
    permissions: string[];
    createdAt: string;
    isDisabled?: boolean;
}
